import React from "react";
import { MessageSquare, CheckCircle, Flag, Star, RefreshCw } from "lucide-react";
import { taskStatusLabel } from "../../utils/statusLabels";

const BADGES = {
  discussing: ["reversia-status-discussing", MessageSquare, "Обсуждается"],
  accepted: ["reversia-status-accepted", CheckCircle, "Принято"],
  completed: ["reversia-status-completed", Flag, "Выполнено"],
  confirmed: ["reversia-status-confirmed", Star, "Подтверждено"],
  open: ["reversia-status-pending", RefreshCw, null],
};

// Бейдж статуса задания для списков обсуждений и шапки чат-модали (TZ8-9: без сырых кодов)
export const TaskStatusBadge = ({ task }) => {
  const [cls, Icon, text] = BADGES[task.status] || ["reversia-status-pending", null, null];
  return (
    <span className={`reversia-status ${cls}`} data-testid="task-status-badge">
      {Icon && <Icon size={11} />}{text || taskStatusLabel(task.status)}
    </span>
  );
};
